import { shallow } from 'zustand/shallow';

import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { useStore } from './useStore.js';

/**
 * Attachs a shallow node to a graph node and returns it
 */
export const useOverridedNodeProps = <P extends { selector?: string | null | undefined }>(
  props: P
): P => {
  const overrideProps = useStore(
    ({ graph }) =>
      props.selector && graph.nodes[props.selector]?.type === FShallowNodeTypesEnum.FOverride
        ? graph.nodes[props.selector]
        : null,
    shallow
  ) as P | null;

  // eslint-disable-next-line no-unused-vars
  const { type: _, ...restOverrideProps } = { ...overrideProps } as any;
  const { parent, ...restProps } = props as any;

  return {
    ...restProps,
    shallowParent: parent,
    shallow: overrideProps ?? null,
    ...restOverrideProps,
  };
};
